import React, { Component } from 'react';
import PropTypes from 'prop-types';

import red from '@material-ui/core/colors/red';
import { TextField, Button, LoadingIndicator, NavigationLink, AppBar } from '../../components';
import { ThemeImages, ThemeColors } from '../../theme';

class ForgotPassword extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
    };
    this.setEmail = this.setEmail.bind(this);
    this.keyPress = this.keyPress.bind(this);
    this.requestResetPassword = this.requestResetPassword.bind(this);
  }

  setEmail(event) {
    this.setState({ email: event.target.value });
  }

  keyPress(event) {
    if (event.key === 'Enter') {
      this.requestResetPassword();
      event.preventDefault();
      return false;
    }
    return true;
  }

  requestResetPassword() {
    this.props.requestPasswordReset({ email: this.state.email });
  }

  render() {
    const formGroupStyle = {
      width: '100%',
      textAlign: 'center',
    };

    const containerStyle = {
      width: '300px',
      margin: '0 auto',
      marginTop: 'calc(50vh - 215px)',
      boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.75)',
    };

    const errorContainerStyle = {
      backgroundColor: red[500],
      textAlign: 'center',
      color: 'white',
    };

    const ErrorMessage = (props) => {
      if (!props.errorMessage) {
        return null;
      }

      return (
        <div style={errorContainerStyle}>
          <span>{props.errorMessage}</span>
        </div>
      );
    };

    const ResetPassword = (props) => {
      if (props.loading) {
        return <LoadingIndicator />;
      }

      return (<Button
        label="Passwort zusenden"
        variant="contained"
        style={{ color: ThemeColors.darkTextOnPrimaryBackground ? 'black' : 'white' }}
        onClick={this.requestResetPassword} color="primary"
      />);
    };

    return (
      <form style={containerStyle} onKeyPress={this.keyPress} noValidate>
        <div style={{ padding: 20 }}>
          <img src={ThemeImages.logoPath} style={{ width: '100%' }} />
        </div>
        <AppBar title="Passwort vergessen" defaultTypography />
        <ErrorMessage {...this.props} />
        <div
          style={{
            ...formGroupStyle,
            marginTop: 10,
          }}
        >
          <TextField
            autoFocus
            required
            hintText="E-Mail"
            value={this.state.email}
            onChange={this.setEmail}
          />
        </div>
        <div
          style={{
            ...formGroupStyle,
            marginTop: 20,
            paddingBottom: 10,
          }}
        >
          <ResetPassword {...this.props} />
        </div>
        <div
          style={{
            ...formGroupStyle,
            marginTop: 20,
            paddingBottom: 10,
          }}
        >
          <NavigationLink to="login">Zurück zur Anmeldung</NavigationLink>

        </div>
      </form>
    );
  }

}
export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/app/login/forgot-password/forgot-password.js